import React, { useEffect, useRef } from "react"
import { makeStyles, withStyles } from "@material-ui/core"
import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"
import CheckIcon from "@material-ui/icons/Check"
import CloseIcon from "@material-ui/icons/Close"
import clsx from "clsx"
import { getOutputItemStatus } from "shared/utils.js"
import TabWrapper from "./tab-wrapper"
import TabPanel from "./tab-panel"
import { UI_RESULT_TYPES } from "shared/consts"

function a11yProps(index) {
  return {
    id: `result-tab-${index}`,
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    minHeight: "100vh",
    paddingTop: theme.spacing(4),
  },
  appBar: {
    backgroundColor: theme.palette.primary.lightest,
    color: theme.palette.primary.main,
    boxShadow: "none",
    paddingTop: 25,
    paddingLeft: 0,
    paddingRight: 0,
    marginLeft: -40, // compensate for tabIndicator arrows
    marginRight: -40, // compensate for tabIndicator arrows
    marginBottom: theme.spacing(2),
    width: "calc(100% + 80px)", // full width plus the fill 40px on each side for tabIndicators
  },
  tabIndicator: {
    backgroundColor: theme.palette.primary.main,
  },
  tabResult: {
    padding: 0,
  },
  tabItem: {
    fontSize: "1.1rem",
    lineHeight: 1.4,
    padding: `0 ${theme.spacing(2)}px 19px`,
    minHeight: "2.75rem",
    borderBottom: `1px solid ${theme.palette.primary.lighter}`,
    color: theme.palette.primary.main,
    fontWeight: 400,
    opacity: 1,
    maxWidth: 500,
  },
  activeTab: {
    fontWeight: 700,
  },
  passCount: {
    color: theme.palette.success.main,
  },
  failCount: {
    color: theme.palette.error.main,
  },
  passFailIcon: {
    verticalAlign: "bottom",
  },
}))

const StyledTabs = withStyles({
  scrollButtons: {
    display: "flex",
    padding: 4,
    justifyContent: "flex-start", // the navigation arrow on the right hand side
    "&:first-child": {
      // the one on the left
      justifyContent: "flex-end",
    },
  },
})(Tabs)

export default function TabbedView(props) {
  const {
    tabs,
    resultTypes,
    children,
    autoScroll,
    selectedCriterion,
    setSelectedCriterion,
    analysisByCategory,
    ...others
  } = props
  const classes = useStyles()
  const sectionRef = useRef(null)
  const handleChange = (event, newValue) => {
    setSelectedCriterion(newValue)
    sectionRef.current.scrollIntoView({ behavior: "smooth" })
  }
  useEffect(function scrollIntoSection() {
    window.requestAnimationFrame(() => {
      if (autoScroll && sectionRef && sectionRef.current) {
        sectionRef.current.scrollIntoView({ behavior: "smooth" })
      }
    })
  }, [])
  return (
    <div className={classes.root} {...others} ref={sectionRef}>
      <TabWrapper
        handleChange={handleChange}
        selectedCriterion={selectedCriterion}
        tabIndicatorHeight={"4px"}
      >
        {resultTypes.map((tabKey, idx) => {
          let numPass = 0
          let numFail = 0
          const tabResults = analysisByCategory[tabKey] || []
          const isPassFailRelevant = tabKey.toLowerCase() !== "overview"
          if (isPassFailRelevant) {
            for (const result of tabResults) {
              const resultStatus = getOutputItemStatus(result)
              if (resultStatus === UI_RESULT_TYPES.PASS) {
                numPass += 1
              } else if (resultStatus === UI_RESULT_TYPES.FAIL) {
                numFail += 1
              }
            }
          }
          return (
            <Tab
              key={tabKey}
              label={<span>{tabs[idx]} {isPassFailRelevant && (<>(
                <span className={classes.failCount}><CloseIcon className={classes.passFailIcon} />{numFail}</span>
                <span className={classes.passCount}><CheckIcon className={classes.passFailIcon} />{numPass}</span>
          )</>)}</span>}
              {...a11yProps(idx)}
              className={clsx({ [classes.tabItem]: true, [classes.activeTab]: idx === selectedCriterion })}
            />
          )
        })}
      </TabWrapper>
      <TabPanel>{children}</TabPanel>
    </div>
  )
}
